import { RootState } from "@/store/store";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

const AuthGuard = () => {
    const { isLoggedIn } = useSelector((state: RootState) => state.auth);

    if (!isLoggedIn) {
        window.location.href = "/auth/login";
        return null; // Return null or a loading spinner while the redirect happens
    }

    return <Outlet />;
};

export default AuthGuard; 